import { FrequencyUnit, SubscriptionFrequency } from "../types";
import { dedupeByKey } from "./entities";

const delimitter = "###";

export const frequencyValueToString = (value: SubscriptionFrequency): string => {
  return `${value.frequency}${delimitter}${value.interval_unit}${delimitter}${value.display}`;
};

export const stringToFrequencyValue = (value: string): SubscriptionFrequency => {
  const [frequency, interval, display] = value.split(delimitter);

  return {
    frequency: parseInt(frequency, 10),
    interval_unit: interval as FrequencyUnit,
    display,
  };
};

type GetSubscriptionOptionsParams = {
  value: SubscriptionFrequency | null;
  recommended: SubscriptionFrequency | null;
  options: SubscriptionFrequency[];
};

export const getSubscriptionFrequencyOptions = (params: GetSubscriptionOptionsParams) => {
  const { value, recommended, options } = params;

  const recommendedOptionKey = recommended ? frequencyValueToString(recommended) : "";

  const optionsWithKeys = dedupeByKey(
    [...(value ? [value] : []), ...(recommended ? [recommended] : []), ...options].map((option) => {
      const key = frequencyValueToString(option);

      return {
        ...option,
        key,
        isRecommended: key === recommendedOptionKey,
      };
    }),
    "key",
    "last",
  );

  return optionsWithKeys;
};
